import { render, staticRenderFns } from "./NavbarPage.vue?vue&type=template&id=809a4680&scoped=true&"
import script from "./NavbarPage.vue?vue&type=script&lang=js&"
export * from "./NavbarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809a4680",
  null
  
)

export default component.exports